import * as Sentry from '@sentry/browser';

import { saveFormDataAXN } from '../../formData/formDataActions';
import { setAlertAXN } from '../../alert/alertActions';
import { saveOcrResponseDataAXN } from "../biometricActions";

import scanDataEditedTrigger from '../helpers/scanDataEditedTrigger';
import isEmptyVAL from '../../../validations/checks/isEmptyVAL';
import { transUTL } from '../../../utils/transUTL';
import loggerUTL from '../../../utils/loggerUTL';

const inputMappingIN = (data, dispatch) => {
  try {
    // MAPPING VARIABLES
    let fullName = '',
      firstName = '',
      lastName = '',
      dateOfBirth = '',
      gender = '',
      pan = '',
      epic = '',
      passportNo = '',
      driversLicenceNumber = '',
      idNo = '';

    if (!isEmptyVAL(data.firstName)) {
      firstName = data.firstName;
    }

    if (!isEmptyVAL(data.lastName)) {
      lastName = data.lastName;
    }

    if (!isEmptyVAL(data.firstName) || !isEmptyVAL(data.lastName)) {
      fullName = `${data.firstName} ${data.lastName}`.trim();
    }

    if (!isEmptyVAL(data.sex)) {
      const sex = data.sex.toLowerCase();
      if (sex === 'f' || sex === 'female') {
        gender = 'F';
      }
      if (sex === 'm' || sex === 'male') {
        gender = 'M';
      }
    }

    if (
      !isEmptyVAL(data.dateOfBirth.day) &&
      !isEmptyVAL(data.dateOfBirth.month) &&
      !isEmptyVAL(data.dateOfBirth.year)
    ) {
      if (data.dateOfBirth.month < 10)
        data.dateOfBirth.month = `0${data.dateOfBirth.month}`;
      if (data.dateOfBirth.day < 10)
        data.dateOfBirth.day = `0${data.dateOfBirth.day}`;
      dateOfBirth = `${data.dateOfBirth.year}-${data.dateOfBirth.month}-${data.dateOfBirth.day}`;
    }
    if (!isEmptyVAL(data.documentNumber)) {
      passportNo = data.documentNumber;
      driversLicenceNumber = data.documentNumber;
    }

    // CHECKS IF DOCUMENT IS EXPIRED
    // docEXP(summary, dispatch);

    // PDF SCANNED DATA TRIGGER
    loggerUTL('Triggering inisializing scanDataEdited...')
    scanDataEditedTrigger('india', false);
    // To store the data(only add in the fields that are showing in FORM page) from Doc scan response
    let ocrResponseData = {
      fullName,
      firstName,
      lastName,
      dateOfBirth,
      passportNo,
      driversLicenceNumber,
    }
    loggerUTL('SAVING SCANNED DATA...', ocrResponseData)
    dispatch(saveOcrResponseDataAXN(ocrResponseData));

    dispatch(
      saveFormDataAXN(
        {
          fullName,
          firstName,
          lastName,
          dateOfBirth,
          gender,
          pan,
          epic,
          idNo,
          passportNo,
        },
        'india'
      )
    );
  } catch (err) {
    dispatch(
      setAlertAXN(transUTL('translateAlertMsg.inputMappingError'), 'error')
    );
    Sentry.captureException('Input mapping error...', data, err);
  }
};

export default inputMappingIN;
